export const SHOW_BANNER = "SHOW_BANNER";
